module.exports = __webpack_public_path__ + "img/getFail.cfb2156c.png";